import Timeline from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/brevity/timeline';
import Animation from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/brevity/animation';
import { ANIMATION_TYPE, TIMELINE_ID, TimelineLabel } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/transition/constants';
import {
    IAnimationCompleteParams,
    IAnimationStartParams,
    IAnimationUpdateParams,
    ITransitionOptions,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-animations/slide-transition/interface';
import { IAnimationSetting } from '@src/slide/domain/ui-model/element-modeles/transition/interface';

export class Transition {
    protected timeline: Timeline;
    protected readonly options: ITransitionOptions;
    private animation: any;

    constructor(options: ITransitionOptions) {
        this.options = options;
        this.timeline = this.generateTimeline();
    }

    public generateTimeline(): Timeline {
        const timelineOptions = {
            id: TIMELINE_ID,
            paused: false,
            callbackScope: this,
            onStart: this.handleTimelineStart.bind(this),
            onUpdate: this.handleTimelineUpdate.bind(this),
            onComplete: this.handleTimelineComplete.bind(this),
        };
        const timeline = new Timeline(timelineOptions);
        timeline.addLabel(TimelineLabel.START);
        const { model, isSwitchForward } = this.options;
        model.getAnimationSetting(isSwitchForward?.()).forEach((item: IAnimationSetting) => {
            const { fromStyle, toStyle, target, label } = item;
            const tempStyle = { ...fromStyle };
            const animation = new Animation({
                type: ANIMATION_TYPE,
                target: tempStyle,
                fromStyle,
                toStyle: {
                    duration: model.animationDuration,
                    onStart: this.handleAnimationStart.bind(this),
                    onUpdate: this.handleAnimationUpdate.bind(this),
                    onComplete: this.handleAnimationComplete.bind(this),
                    onUpdateParams: [{ target, style: tempStyle }],
                    onStartParams: [{ target }],
                    onCompleteParams: [{ target }],
                    ...toStyle,
                },
            });
            timeline.add(animation, label ?? TimelineLabel.START);
        });
        timeline.addLabel(TimelineLabel.COMPLETE);
        return timeline;
    }

    public startAnimation() {
        this.animation = this.timeline.tweenFromTo(TimelineLabel.START, TimelineLabel.COMPLETE, {});
    }

    public stopAnimation(): boolean {
        if (this.animation?.isActive?.()) {
            this.animation.progress(1).kill();
            return true;
        }
        return false;
    }

    public isActive(): boolean {
        return this.animation?.isActive?.();
    }

    public dispose(): void {
        this.timeline.clear();
    }

    private handleTimelineStart() {
        this.options.handleTimelineStart?.();
    }

    private handleTimelineUpdate() {
        this.options.handleTimelineUpdate?.();
    }

    private handleTimelineComplete() {
        this.options.handleTimelineComplete?.();
    }

    private handleAnimationStart(params: IAnimationStartParams): void {
        this.options.handleAnimationStart?.(params);
    }

    private handleAnimationUpdate(params: IAnimationUpdateParams): void {
        this.options.handleAnimationUpdate?.(params);
    }

    private handleAnimationComplete(params: IAnimationCompleteParams): void {
        this.options.handleAnimationComplete?.(params);
    }
}
